import React from 'react';
import styles from '../../../styles/components/layout/HeaderSection.module.css';
import { isSafari } from '../../../utils/helpers/utils';
import { OptimizedImage } from '../../common';

/**
 * Header Contact Component
 * Displays contact information (phone number)
 * 
 * @param {Object} contact - Contact object with value property
 * @param {String} className - Additional CSS classes
 * @param {Boolean} isMobile - Whether this is for mobile layout
 */
const HeaderContact = ({ contact, className = '', isMobile = false }) => {
    if (!contact || !contact.value) return null;

    if (isMobile) {
        return (
            <a href={`tel:${contact.value}`} className={`${styles['call-button']} ${className}`}>
                <OptimizedImage 
                    src="https://images.hirego.co.uk/assets/Icons/Phone.svg" 
                    alt="Call-us" 
                    width={25} 
                    height={25} 
                    priority={false}
                    loading="lazy"
                    quality={65}
                    sizes="25px"
                />
            </a>
        );
    }

    return (
        <div className={`nav-item ms-4 d-flex align-items-center gap-2 ${className}`}>
            <OptimizedImage
                src="https://images.hirego.co.uk/assets/Icons/Phone.svg"
                alt="phone"
                height={24}
                width={24}
                priority={false}
                loading="lazy"
                quality={65}
                sizes="25px"
            />
            <div className="d-flex flex-column">
                <a
                    href={`tel:${contact.value}`}
                    className={`${styles['btn-account']} ${styles['menu-links']} ${styles['bold-font']}`}
                >
                    {contact.value}
                </a>
            </div>
        </div>
    );
};

export default HeaderContact;
